function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "info_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1033",
  transform: "translate(1967 4056)",
  fill: "#fff",
  stroke: "#707070",
  d: "M0 0h18v18H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "info_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5334",
  d: "M39.364-12.636A9 9 0 0040.483-24a9 9 0 00-10.927-3.315 9 9 0 00-5.383 10.07A9 9 0 0033-10a9 9 0 006.364-2.636z",
  transform: "translate(-24 28)",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "info_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5333",
  d: "M0 551.208h1151.934V-171H0z",
  transform: "translate(0 171)",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "info_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5337",
  d: "M32.315-22a.664.664 0 01.469.2.664.664 0 01.193.47v4.9a.665.665 0 01-.662.667.665.665 0 01-.662-.663v-4.237h-1.012a.667.667 0 01-.641-.67.667.667 0 01.641-.667h1.674zM32-25a1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1 1 1 0 011-1z",
  transform: "translate(-30 25)",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "info_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5336",
  d: "M0 471h1024v-642H0z",
  transform: "translate(0 171)",
  fill: "none"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Info icon",
  transform: "translate(-1967 -4056)",
  clipPath: "url(#info_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1338"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1228",
  clipPath: "url(#info_svg__b)",
  transform: "translate(1967 4056)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1227",
  transform: "translate(-26.998 -160.866)",
  clipPath: "url(#info_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5332",
  d: "M21.374 155.241h29.249v29.249H21.374z",
  fill: "#2e77d0"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1230",
  transform: "translate(1973.923 4059.886)",
  clipPath: "url(#info_svg__d)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1229",
  transform: "translate(-30 -146)",
  clipPath: "url(#info_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5335",
  d: "M25 141h13v19.233H25z",
  fill: "#fff"
})))));

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _ref, _ref2);
}

export default SvgInfo;